<template>
    <LoadingPage
        :v-if="state.loadingApp"
        text="Carregando página..."
        :show="state.loadingApp"
    />
  
    <ModalFactory />
    <DynamicDialog  />
    <ConfirmDialog></ConfirmDialog>

    <RouterView />

    <FeedbackNotification />

  
  <!--   <div v-if="store().websocket.status == 'error'" class="fixed top-0 z-50 right-5 top-5 w-[320px] rounded-xl p-3 text-start bg-red-500">
        <span class="text-white text-md">Sua conexão foi perdida ou seu chat está aberto em outra aba. Atualize a página para continuar.</span>
        
    </div> -->
    <!-- Esse wrapper é necessário para que o iframe do chat interno seja arrastável. -->
    <div
        id="iframeInternalChatWrapper"
        ref="el"
        :style="style"
        style="position: fixed;"
        class="relative group z-[99999]"
        @mouseover="onMouseMove"
        @mouseleave="onMouseLeave"
    >
        <div
            v-if="groupHover"
            class="
          absolute
          z-50
          text-white
          -top-1
          -left-1
          transition-all
          h-6
          w-6
          rounded-full
          justify-center
          items-center
          text-xl
          hover:cursor-move
          select-none
          bg-black
          flex
        "
        >
            <Unicon
                name="draggabledots"
                whidth="12"
                height="12"
            />
        </div>
    </div>
</template>

<script setup>
  import {ref, reactive, computed, onMounted, watch, onBeforeMount, onUnmounted} from 'vue'
    import { useDraggable, breakpointsTailwind, useBreakpoints, useWindowSize } from '@vueuse/core'
    import FeedbackNotification from '@/components/utils/FeedbackNotification.vue'
    import ModalFactory from '@/components/modal/ModalFactory.vue'
    import LoadingPage from '@/components/navigation/LoadingPage.vue'
    import { sendWebSocketMessage, closeWebsocket, startWebSocket } from '@/composables/chat/useWebSocket'
    import { useChatStore } from '@/stores/chat'
    import { useUsersStore } from '@/stores/users'
    import { useWindowFocus } from '@vueuse/core'
    import DynamicDialog from 'primevue/dynamicdialog';
    import ConfirmDialog from 'primevue/confirmdialog'
    // import '@/plugins/DisableDevTools'
    import useChat from '@/composables/chat/useChat'
    import WebSocketStatus from '@/views/chat/components/Utils/WebSocketStatus.vue'
    import useAccessTimeMonitor from '@/composables/useAccessTimeMonitor'

    const store = useChatStore()
    const userStore = useUsersStore

    // Monitor contínuo do horário de acesso (access_time)
    useAccessTimeMonitor()
  
    // Show loading page only in production

    let state = reactive({ loadingApp: false })
    if (import.meta.env.PROD) {
        state.loadingApp = true
        window.onload = () => (state.loadingApp = false)
    }

    const focused = useWindowFocus()
    store().focused = focused



    const handleVisibilityChange = () => {
        if (!document.hidden && !focused.value) {
            // Aba voltou a ficar visível
            if (store().websocket.status != 'connected') {
                // Reconectar com force=true para derrubar outras conexões
                reconnectWithForce()
            }
        }
    }

    const reconnectWithForce = () => {
        // Fechar conexão atual
        closeWebsocket()
        
        // Reconectar com force=true
        const path = store().websocket.path // Você precisará armazenar isso
        const token = store().websocket.token
       // startWebSocket(path, token, true) // force=true

        store().initializeChat()
    }
    
    // Check if you use dark mode theme
    const checkThemeBrowser = !('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches
    const checkThemePrefence = localStorage.theme === 'dark'
    localStorage?.theme ?? localStorage.setItem('theme', 'light')
    if (checkThemeBrowser || checkThemePrefence) {
        if (localStorage.getItem('theme') === 'dark') {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
    }

    const el = ref(null)
    const groupHover = ref(false)

    const { width: pageWidth, height: pageHeight } = useWindowSize()

    const breakpoints = useBreakpoints(breakpointsTailwind)
    const minXDraggable = computed(() => (breakpoints.greater('md').value ? 100 : 10))
    const minYDraggable = computed(() => (10))

    const { x, y } = useDraggable(el, {
        initialValue: { x: parseInt(pageWidth.value) - 100, y: parseInt(pageHeight.value) - 100 },
    })

    const style = computed(() => {
        const adjustedLeft = x.value < minXDraggable.value ? minXDraggable.value : x.value > pageWidth.value - 100 ? pageWidth.value - 100 : x.value
        const adjustedTop = y.value < minYDraggable.value ? minYDraggable.value : y.value > pageHeight.value - 100 ? pageHeight.value - 100 : y.value

        return {
            left: `${adjustedLeft}px`,
            top: `${adjustedTop}px`,
        }
    })

    function onMouseMove() {
        groupHover.value = true
    }

    function onMouseLeave() {
        groupHover.value = false
    }

    const observer = ref(null)

    const savedX = ref(null)
    const savedY = ref(null)

    window.onresize = function() {
        const targetNode = document.querySelector('#iframeInternalChatWrapper iframe')
        if (targetNode) {
            targetNode.style.left = style.value.left
            targetNode.style.top = style.value.top
        }
    }

    onMounted(() => {

        document.addEventListener('visibilitychange', handleVisibilityChange)

        function checkIframeCreated() {
            const targetNode = document.querySelector('#iframeInternalChatWrapper iframe')
            if (targetNode) {
                if (!observer.value) {
                    observer.value = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                const targetNodeClassList = targetNode.classList

                                if (targetNodeClassList.contains('open')) {
                                    if (!savedX.value && !savedY.value) {
                                        savedX.value = x.value
                                        savedY.value = y.value
                                    }

                                    const margin = 30
                                    const widgetWidth = Math.min(730, parseInt(pageWidth.value) - 2 * margin)
                                    const widgetHeight = Math.min(680, parseInt(pageHeight.value) - 2 * margin)

                                    x.value = Math.min(parseInt(pageWidth.value) - widgetWidth - margin, Math.max(margin, x.value))
                                    y.value = Math.min(parseInt(pageHeight.value) - widgetHeight - margin, Math.max(margin, y.value))

                                } else {
                                    if (savedX.value && savedY.value) {
                                        x.value = savedX.value
                                        y.value = savedY.value
                                    }

                                    savedX.value = null
                                    savedY.value = null
                                }
                            }
                        })
                    })

                    observer.value.observe(targetNode, {
                        attributes: true,
                        attributeFilter: ['class'],
                    })
                }

                clearInterval(checkInterval)
            }
        }

        const checkInterval = setInterval(checkIframeCreated, 100)
        //const checkIntervalPong = setInterval(checkPong, 1000)


        //sendWebSocketMessage(mensagem)

        setInterval(function() {
            
            sendWebSocketMessage({ 'type': 'ping', 'user': userStore().me?.id, 'tokenValidate': store().websocket?.token })

        },55000) 

      
    })

    onUnmounted(() => {
        //clearInterval(checkIntervalPong)
        clearInterval(checkInterval)
        document.removeEventListener('visibilitychange', handleVisibilityChange)

    })

    onBeforeMount(() => {
      if (
        window.origin === 'https://chatmix.com.br' ||
        window.origin === 'http://chatmix.com.br'
        ) {
        window.location.href = 'https://www.chatmix.com.br';
      }
    })


 


</script>
